<template>
  <v-container class="uniformity-container">
    <v-row class="mt-3">
      <v-col align="end" style="align-content: center;">
        <v-icon class="d-inline icon-center" color="#00202F" size="1rem">date_range</v-icon>
        <p class="mb-0 d-inline">{{uniformityData && uniformityData.workDate ? formatDate(uniformityData.workDate) : '-'}}</p>
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <PdfViewer v-if="uniformityData && uniformityData.pdfFile && uniformityData.pdfFile.url" :pdfUrl="uniformityData.pdfFile.url" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import PdfViewer from '../Shared/PdfViewer.vue'

export default {
  props: {
    uniformityData: {
      type: Object,
      required: true
    }
  },
  components: {
    PdfViewer
  },
  methods: {
    formatDate (date) {
      if (!date) return '-'
      const d = new Date(date)
      return d.toLocaleDateString('es-AR', { year: 'numeric', month: '2-digit', day: '2-digit' })
    }
  }
}
</script>

<style scoped>
.uniformity-container {
  padding-left: calc(48px + 25%) !important;
}
</style>



// WEBPACK FOOTER //
// Uniformity.vue?318cc097